<template>
    <div>
        <ModalCommon :id="`configModalCommon-${id}`" :config="config" @save="handleConditionFMT()" @close="handleClear()">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.campaignStartDate') }}</label>
                    <div class="col-sm-8">
                        {{ formatDateCommon(dataForm?.campaign_start_date, 'dateTimeJP') ?? '' }}
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.campaignEndDate') }}</label>
                    <div class="col-sm-8">
                        {{ formatDateCommon(dataForm?.campaign_end_date, 'dateTimeJP') ?? '' }}
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.secretariatType') }}</label>
                    <div class="col-sm-8">
                        {{ joinValue(dataForm?.categories) ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.deliveryCycle') }}</label>
                    <div class="col-sm-8">
                        <Multiselect :id="`select-cycle`" :value.sync="dataForm.cycle" :options="dataCycle" :config.sync="configFieldCycle" />
                    </div>
                </div>

                <div v-if="dataForm.cycle.id === 1" class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.closingDate') }} <span class="text-danger">*</span></label>
                    <div class="col-sm-8">
                        <Multiselect
                            :id="`select-closing-date`"
                            :value.sync="dataForm.closing_date"
                            :options="dataDayOfWeek"
                            :config.sync="configFieldClosingDate"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-4">
                        <label style="white-space: nowrap">{{ $t('document.reportDate') }} <span class="text-danger">*</span></label>
                        <p class="mb-0" style="font-size: 13px">{{ $t('document.noteFMT') }}</p>
                    </div>
                    <div class="col-sm-8">
                        <Multiselect
                            :id="`select-report-date`"
                            :value.sync="dataForm.report_date"
                            :options="REPORT_DATE"
                            :config="{
                                trackBy: '',
                                label: '',
                                error: false
                            }"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.skipTheFirstWeekClosing') }}</label>
                    <div class="col-sm-8">
                        <InputCheckBox
                            :model.sync="dataForm.skip_the_first_week_closing"
                            :id="`check-skip_the_first_week_closing`"
                            :value="dataForm.skip_the_first_week_closing"
                            :label="``"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4" style="white-space: nowrap">{{ $t('document.includeItOneWeekBefore') }}</label>
                    <div class="col-sm-8">
                        <InputCheckBox
                            :model.sync="dataForm.include_it_one_week_before"
                            :id="`check-include_it_one_week_before`"
                            :value="dataForm.include_it_one_week_before"
                            :label="``"
                        />
                    </div>
                </div>
            </form>
        </ModalCommon>
    </div>
</template>

<script>
import Multiselect from '@/components/Multiselect/main.vue';
import ModalCommon from '@/components/Modal/main.vue';

import { cycleFMT, DayOfWeek, findDeliveryCycle } from '@/views/pages/documents/main.js';
import { formatDateCommon } from '@/utils/format';
import { InputCheckBox } from '@/components/Input';
import { configs, REPORT_DATE } from '../../main';
import { masterMethods } from '@/state/helpers';
import { validateField } from '@/utils/validate';
import { mapState } from 'vuex';

export default {
    name: 'ModalCondition',
    components: {
        Multiselect,
        ModalCommon,
        InputCheckBox
    },
    props: {
        id: {
            required: true
        },
        dataCondition: {
            type: Object,
            default: () => null
        },
        config: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        ...mapState({
            ...mapState('master', ['dataParamaterFMT'])
        })
    },
    data() {
        return {
            dataForm: null,
            dataCycle: cycleFMT,
            dataDayOfWeek: DayOfWeek,
            configFieldCycle: configs.configFieldCycle,
            configFieldClosingDate: configs.configFieldClosingDate,
            configFieldReportDate: configs.configFieldReportDate,
            REPORT_DATE: REPORT_DATE,
            isLoading: false
        };
    },
    methods: {
        ...masterMethods,

        handleValidateField(configField) {
            validateField(configField);
        },

        handleConditionFMT() {
            this.actionDataParamaterFMT(this.dataForm);
            this.$emit('update:dataCondition', this.dataForm);
            this.config.model = false;
            this.isLoading = false;
        },

        handleClear() {
            this.configFieldClosingDate.error = false;
            this.configFieldReportDate.error = false;
            this.dataForm = this.handleMapData(this.dataCondition);
            this.actionDataParamaterFMT(this.dataForm);
            this.$emit('update:dataCondition', this.dataForm);
            this.config.model = false;
        },

        formatDateCommon(date, type) {
            return formatDateCommon(date, type);
        },

        joinValue(param) {
            if (!param || !param?.length) return '';
            return param.map((o) => o?.category?.value ?? '').join('、');
        },

        handleMapData(newdataCondition) {
            this.dataForm = {
                ...newdataCondition,
                campaign_start_date: this.config.detailBeginForDocument.campaign_start_date,
                campaign_end_date: this.config.detailBeginForDocument.campaign_end_date,
                categories: this.config.detailBeginForDocument.categories,
                cycle: findDeliveryCycle(this.dataParamaterFMT?.delivery_cycle ?? this.config.detailBeginForDocument.fmt_parameter_cycle),
                report_date: this.dataParamaterFMT?.report_day ?? 3,
                closing_date: this.dataParamaterFMT?.closing_day?.id ? this.dataParamaterFMT.closing_day : DayOfWeek[4],
                skip_the_first_week_closing: this.dataParamaterFMT?.is_skip_the_first_week,
                include_it_one_week_before: this.dataParamaterFMT?.is_merged_with_the_last_week
            };
            return this.dataForm;
        }
    },
    watch: {
        dataCondition: {
            handler: function (newdataCondition) {
                this.dataForm = this.handleMapData(newdataCondition);
            },
            immediate: true,
            deep: true
        },

        'config.model': {
            handler: function (valShow) {
                if (valShow) {
                    this.dataForm = this.handleMapData(this.dataCondition);
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
